import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PreferedCard from './PreferedCard';
import { formatAddressToString, getAllAddressesMappedByType } from '../../services/addresses';

const PreferedCardDemo = () => {
  const addresses = getAllAddressesMappedByType();

  return (
    <Container>
      <Container className="mt-10">
        <h4>Preferred Cards</h4>
        <Row>
          <Col className={'col-12 col-lg-3 mt-7'}>
            <PreferedCard
              id="pc-1"
              title={'Work'}
              editButtonName={'Edit address'}
              onDelete={() => console.log('this is delete modal')}
              onEdit={() => console.log('this is edit modal')}
              onChange={() => console.log('this is switch change')}
            >
              {
                <div className={'fw-light text-fs-6'}>
                  {formatAddressToString(addresses.work[0])}
                </div>
              }
            </PreferedCard>
          </Col>
          <Col className={'col-12 col-lg-3 mt-7'}>
            <PreferedCard
              id="pc-2"
              title={'Alternate'}
              editButtonName={'Edit address'}
              onDelete={() => console.log('this is delete modal')}
              onEdit={() => console.log('this is edit modal')}
              onChange={() => console.log('this is switch change')}
            >
              {
                <div className={'fw-light text-fs-6'}>
                  {formatAddressToString(addresses.alt[0])}
                </div>
              }
            </PreferedCard>
          </Col>
          <Col className={'col-12 col-lg-3 mt-7'}>
            <PreferedCard
              id="pc-3"
              title={'Home'}
              editButtonName={'Edit address'}
              onDelete={() => console.log('this is delete modal')}
              onEdit={() => console.log('this is edit modal')}
              onChange={() => console.log('this is switch change')}
              checked
            >
              {
                <div className={'fw-light text-fs-6'}>
                  {formatAddressToString(addresses.home[0])}
                </div>
              }
            </PreferedCard>
          </Col>
          <Col className={'col-12 col-lg-3 mt-7'}>
            <PreferedCard
              id="pc-4"
              title={'Work'}
              editButtonName={'Edit email'}
              onDelete={() => console.log('this is delete modal')}
              onEdit={() => console.log('this is edit modal')}
              onChange={() => console.log('this is switch change')}
            >
              {
                <div className={'fw-light text-fs-6'}>
                  terry.smith@company.com
                </div>
              }
            </PreferedCard>
          </Col>
          <Col className={'col-12 col-lg-3 mt-7'}>
            <PreferedCard
              id="pc-5"
              title={'Work'}
              editButtonName={'Edit email'}
              onDelete={() => console.log('this is delete modal')}
              onEdit={() => console.log('this is edit modal')}
              onChange={() => console.log('this is switch change')}
              checked
            >
              {
                <div className={'fw-light text-fs-6'}>
                  terry.smith@company.com
                </div>
              }
            </PreferedCard>
          </Col>
          <Col className={'col-12 col-lg-3 mt-7'}>
            <PreferedCard
              title={'Address'}
              onButtonClick={() => console.log('this is change modal')}
              variant={'selected'}
            >
              {
                <Fragment>
                  <div>Work</div>
                  <div className={'fw-light text-fs-6'}>
                    {formatAddressToString(addresses.work[0])}
                  </div>
                </Fragment>
              }
            </PreferedCard>
          </Col>
          <Col className={'col-12 col-lg-3 mt-7'}>
            <PreferedCard
              title={'Work'}
              variant={'selected'}
              onButtonClick={() => console.log('this is change modal')}
            >
              {
                <Fragment>
                  <div>Mail</div>
                  <div className={'fw-light text-fs-6'}>
                    terry.smith@company.com
                  </div>
                </Fragment>
              }
            </PreferedCard>
          </Col>
          <Col className={'col-12 col-lg-3 mt-7'}>
            <PreferedCard
              title={'Text'}
              variant={'selected'}
              onButtonClick={() => console.log('this is change modal')}
            >
              {
                <Fragment>
                  <div>Work</div>
                  <div className={'fw-light text-fs-6'}>(555) 333-44444</div>
                </Fragment>
              }
            </PreferedCard>
          </Col>
          <Col className={'col-12 col-lg-3 mt-7'}>
            <PreferedCard
              title={'Main account'}
              editButtonName={'Edit bank'}
              onDelete={() => console.log('this is delete modal')}
              onEdit={() => console.log('this is edit modal')}
              isSwitch={false}
            >
              {
                <Fragment>
                  <div className={'fw-light text-light-grey'}>Checking</div>
                  <div className={'fs-6'}>*****6789</div>
                  <div>Maple Bank</div>
                </Fragment>
              }
            </PreferedCard>
          </Col>
          <Col className={'col-12 col-lg-3 mt-7'}>
            <PreferedCard
              title={'Family funds'}
              editButtonName={'Edit bank'}
              onDelete={() => console.log('this is delete modal')}
              onEdit={() => console.log('this is edit modal')}
              isSwitch={false}
            >
              {
                <Fragment>
                  <div className={'fw-light text-light-grey'}>Savings</div>
                  <div className={'fs-6'}>*****4733</div>
                  <div>Bacon Bank</div>
                </Fragment>
              }
            </PreferedCard>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default PreferedCardDemo;
